// extracted by mini-css-extract-plugin
module.exports = {"inlineImage":"inlineImage-module--inlineImage--3smKU","inlineImageWithCaption":"inlineImage-module--inlineImageWithCaption--1vtqK"};